import PropTypes from 'prop-types'

import { translate } from '@/utils/translations'

const ProductInfo = ({ edition, productClick, title }) => (
  <>
    <button
      className='vst-btn--related-asset-title product-info__product-heading'
      onClick={productClick}
    >
      <div className='product-info__title'>
        {title}
      </div>
    </button>
    <If condition={edition}>
      <div className='product-info__edition'>
        {translate('common.edition')}{`: `}{edition}
      </div>
    </If>
  </>
)

ProductInfo.propTypes = {
  edition: PropTypes.string,
  productClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

export default ProductInfo
